import React, { createContext, useContext, useMemo } from 'react';
import { chefById, currentChefId } from '../data/chefs';
import { customer } from '../data/customer';
import type { Chef } from '../types/chef';
import type { Customer } from '../types/customer';
export type Viewer = 'guest' | 'customer' | 'chef';
interface SessionValue {
  viewer: Viewer;
  isSignedIn: boolean;
  customer: Customer;
  chef: Chef;
  /** Home route for the signed-in audience. */
  home: string;
}
const SessionContext = createContext<SessionValue | null>(null);
export function SessionProvider({
  viewer,
  children
}: {
  viewer: Viewer;
  children: React.ReactNode;
}) {
  const value = useMemo<SessionValue>(() => ({
    viewer,
    isSignedIn: viewer !== 'guest',
    customer,
    chef: chefById(currentChefId) as Chef,
    home: viewer === 'chef' ? '/chef' : viewer === 'customer' ? '/app/bookings' : '/'
  }), [viewer]);
  return <SessionContext.Provider value={value} data-id="element-1002" data-mp="1c5xn7wfbr206">{children}</SessionContext.Provider>;
}
export function useSession(): SessionValue {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used inside SessionProvider');
  return ctx;
}